import { ProductInterface } from '../Model/Product';
import { AbstractFilter } from './AbstractFilter';
import { FilterInterface, FilterType } from './FilterInterface';

export type CallbackFilterType<T> = (product: ProductInterface, value: T) => boolean;

/**
 */
export class CallbackFilter<T> extends AbstractFilter<T> {
    private readonly callback: CallbackFilterType<T>;

    constructor(
        attributeKey: string,
        expectedValue: T,
        type: FilterType,
        isActive: boolean,
        callback: CallbackFilterType<T>
    ) {
        super(attributeKey, expectedValue, type, isActive);
        this.callback = callback;
    }

    public matches(product: ProductInterface): boolean {
        return this.callback.call(this, product, this.value);
    }

    protected clone(): FilterInterface<T> {
        return new CallbackFilter(this.keyPath, this.value, this.type, this.isActive, this.callback);
    }
}
